import React from "react";

const LABEL_STYLE: React.CSSProperties = {
  fontSize: 12,
  textTransform: "uppercase",
  letterSpacing: 0.5,
  color: "#64748b",
  fontWeight: 600,
};

interface FieldLabelProps {
  children: React.ReactNode;
  required?: boolean;
}

const FieldLabel: React.FC<FieldLabelProps> = ({ children, required }) => (
  <label className="form-label fw-semibold" style={LABEL_STYLE}>
    {children} {required && <span className="text-danger">*</span>}
  </label>
);

export default FieldLabel;
